/**
 * Apparition au défilement — équivalent du composant <Reveal /> de l'ancien site.
 *
 * Chaque `.ci-reveal` passe en `.is-visible` dès qu'il entre dans le viewport,
 * puis n'est plus observé. Le délai d'échelonnement est porté par l'attribut
 * `data-ci-reveal-delay` (en ms), écrit par les sections Liquid.
 */
(() => {
  const SELECTOR = '.ci-reveal:not(.is-visible)';

  const reveal = (element) => {
    const delay = Number(element.dataset.ciRevealDelay ?? 0);
    if (delay > 0) element.style.transitionDelay = `${delay}ms`;
    element.classList.add('is-visible');
  };

  // Sans IntersectionObserver (ou en mouvement réduit), tout est affiché d'emblée.
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window) || reducedMotion) {
    const showAll = () => document.querySelectorAll(SELECTOR).forEach((el) => el.classList.add('is-visible'));
    document.addEventListener('DOMContentLoaded', showAll);
    showAll();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  const observeAll = () => document.querySelectorAll(SELECTOR).forEach((el) => observer.observe(el));

  observeAll();
  document.addEventListener('DOMContentLoaded', observeAll);

  // L'éditeur de thème remplace le DOM d'une section à chaque modification.
  document.addEventListener('shopify:section:load', observeAll);
})();
